///<reference path="../../formation/question.model.ts"/>
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question, TypeReponse} from '../../formation';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ListeChoix, ListeChoixService} from '../../candidature';

@Component({
    selector: 'jhi-reponse-component',
    templateUrl: 'reponse.component.html'
})
export class ReponseComponent implements OnInit {

    @Input()  set questions(questions: Question[]) {
        this._questions = questions;
        this.rechercheListeChoix();
    }

    @Input() isEditable = true;
    @Input() currentLang: string;
    @Output() btnActivation = new EventEmitter();

    aide: Question;
    ensembleListeChoix: {[nomListe: string]: ListeChoix; } = {};
    nomsListChoix: String[] = [];
    private _questions:  Question[] ;
    public typeReponse =  TypeReponse;
    public QuestionClass = Question ;

    constructor(private modalService: NgbModal,
                private listeChoixService: ListeChoixService
                ) {
    }

    ngOnInit() {
    }

    // recherche des valeurs des listes de choix
    private rechercheListeChoix() {
        if (this._questions && this._questions.length > 0) {
            this._questions.forEach(question => {
                if (question.typeReponse === 'LISTCHOIX') {
                    let nomListe: string = question.reponseComplement;
                    question.reponseComplement = nomListe;
                    if (!this.ensembleListeChoix[nomListe]) {
                        this.listeChoixService.query({type: nomListe}).subscribe(services => {
                            this.ensembleListeChoix[nomListe] = services.json();
                            this.nomsListChoix.push(nomListe);
                         });
                    }
                }
                if (question.typeReponse === 'CHECKBOX') {
                    question.reponse = !(question.reponse == null || question.reponse.toString() != 'true');
                }

            });
        }
    }

// Open la popup d'aide
    openAide(questionModal, question) {
        this.aide = question;
        this.modalService.open(questionModal);
    }

    libelleChoix(listeChoix: ListeChoix) {
        if (this.currentLang === 'en' && listeChoix.libelleEn != null) {
            return listeChoix.libelleEn;
        } else {
            return listeChoix.libelle;
        }
    }

    libelleQuestion(question: Question) {
        let languageLibelle: String = (Question.getLibelleLangue(question, this.currentLang));
        let libelleQuestion: String = languageLibelle;
        if (languageLibelle != null) {
            if (languageLibelle.search('/#|/') > 0) {
                let splitLibelle: string[] = languageLibelle.split('#|');
                if (splitLibelle.length > 1) {
                    if (splitLibelle.length > 5) {
                        libelleQuestion = splitLibelle[0] + splitLibelle[4];
                    } else {
                        libelleQuestion = splitLibelle[0];
                    }
                }
            }
        }
        return libelleQuestion;
    }

    questionAvecBouton(question: Question) {
        return Question.questionAvecBouton(question, this.currentLang);
    }

    titreBouton(question: Question) {
        return Question.titreBouton(question, this.currentLang);
    }

    actionBouton(question: Question) {
        let languageLibelle: String = Question.getLibelleLangue(question, this.currentLang);
        let btnAction: String;
        if (languageLibelle != null) {
            let splitLibelle: string[] = languageLibelle.split('#|');
            if (splitLibelle.length > 1) {
                btnAction = splitLibelle[1];
            }
        }
        return btnAction;
    }

    clickBouton(question: Question) {
        let btnAction: String;
        btnAction = this.actionBouton(question);
        if (btnAction != null) {
            this.btnActivation.emit({btnAction});
        }
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/blocks/reponse/reponse.component.ts